import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal, PopupModal } from "../../Components/Modal/Modals";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import { apcReset, GetAllAPCAdders } from "../../Redux/APCAdder/ApcAdderSlice";
import AdderStatusConfirm from "../Adders/AdderStatusConfirm";
import EditAdder from "../Adders/EditAdder";
import {
    Table,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    CircularProgress,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import { toast } from "react-toastify";
import StateVendorShow from "../Vendors/StateVendorShow";
import APCShow from "./APCShow";
import { DeleteAddreMethod } from "../../Redux/AddersSlice/AddersSlice";

function AllApcAdder() {
    const dispatch = useDispatch();

    const { apc, isLoading } = useSelector((state) => state.apc_adders);
    const APC_ADDER = apc?.data || [];

    // Delete APC Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [tableId, setTableId] = useState(null);
    const [showAPC, setShowAPC] = useState(0);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };

    const CallNotificationMethod = async () => {
        await toast.success("Adder Deleted Success");
        await GetAllAPC();
        await dispatch(apcReset());
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteAddreMethod(data.id));
        await CallNotificationMethod();
    };
    const handelDeleteAdder = async (data) => {
        handleOpen(data);
    };
    const handelShowAPCADDER = (id) => {
        id === showAPC ? setShowAPC(0) : setShowAPC(id);
    };
    const GetAllAPC = async () => {
        await dispatch(GetAllAPCAdders());
        await dispatch(apcReset());
    };
    React.useEffect(() => {
        GetAllAPC();
    }, [dispatch]);
    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <TableContainerStyled>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell> Adder </TableCell>
                                <TableCell> Count </TableCell>
                                <TableCell> Service Type </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {APC_ADDER?.map((adder, index) => (
                                <>
                                    <TableRowStyled key={adder.id}>
                                        <TableCellStyle>
                                            {index + 1}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {adder.name}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {adder.users
                                                ? adder.users.length
                                                : "0"}
                                        </TableCellStyle>

                                        <TableCellStyle align="center">
                                            <IconButton>
                                                <Link
                                                    to={
                                                        "/dashboard/adders/edit=" +
                                                        adder.id
                                                    }
                                                >
                                                    <Edit color="success" />
                                                </Link>
                                            </IconButton>
                                            <IconButton
                                                onClick={() =>
                                                    handelDeleteAdder(adder)
                                                }
                                            >
                                                {tableId === adder.id && (
                                                    <ProgressStyled>
                                                        <CircularProgress
                                                            size={30}
                                                            color="error"
                                                        />
                                                    </ProgressStyled>
                                                )}

                                                <ProgressStyled>
                                                    <Delete color="error" />
                                                </ProgressStyled>
                                            </IconButton>
                                            <IconButton
                                                onClick={(e) =>
                                                    handelShowAPCADDER(adder.id)
                                                }
                                            >
                                                <Visibility color="primary" />
                                            </IconButton>
                                        </TableCellStyle>
                                    </TableRowStyled>
                                    {adder.users && showAPC === adder.id && (
                                        <APCShow users={adder.users}></APCShow>
                                    )}
                                </>
                            ))}
                        </TableBody>
                    </Table>

                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLoading}
                    />
                </TableContainerStyled>
            )}
        </>
    );
}

export default AllApcAdder;
